import { CARD_LAYOUT_SIZES, normalizeCardLayoutSize } from "./branding-defaults";
import { PREVIEW_HOME_CARDS } from "./branding-cards-config";

export const cardConfigByField = (uploadField) =>
  PREVIEW_HOME_CARDS.find((card) => card.uploadField === uploadField);

export const isCardAvailable = (form, card) => {
  if (card.isAd && !form[`${card.uploadField}Available`]) return false;
  return true;
};

export const getEnabledPreviewCards = (form) =>
  PREVIEW_HOME_CARDS.filter((card) => isCardAvailable(form, card) && Boolean(form[card.enabledKey])).sort(
    (a, b) => Number(form[a.priorityKey] || 0) - Number(form[b.priorityKey] || 0),
  );

export const getDisabledPreviewCards = (form) =>
  PREVIEW_HOME_CARDS.filter((card) => isCardAvailable(form, card) && !form[card.enabledKey]);

export const prioritiesFromOrder = (orderedUploadFields) => {
  const updates = {};
  orderedUploadFields.forEach((uploadField, index) => {
    const card = cardConfigByField(uploadField);
    if (card?.priorityKey) {
      updates[card.priorityKey] = index;
    }
  });
  return updates;
};

export const nextCardPriority = (form) => {
  const enabled = getEnabledPreviewCards(form);
  if (enabled.length === 0) return 0;
  return Math.max(...enabled.map((card) => Number(form[card.priorityKey] || 0))) + 1;
};

export const defaultSizeForCard = (card) => {
  const options = card.availableSizes || CARD_LAYOUT_SIZES;
  return options.includes("MEDIUM") ? "MEDIUM" : options[0];
};

export const cycleCardSize = (current, availableSizes, direction = 1) => {
  const options = (availableSizes?.length ? availableSizes : CARD_LAYOUT_SIZES).map(normalizeCardLayoutSize);
  const unique = CARD_LAYOUT_SIZES.filter((size) => options.includes(size));
  const sizes = unique.length ? unique : CARD_LAYOUT_SIZES;
  const currentNormalized = normalizeCardLayoutSize(current);
  const index = Math.max(0, sizes.indexOf(currentNormalized));
  const nextIndex = Math.min(sizes.length - 1, Math.max(0, index + direction));
  return sizes[nextIndex];
};

export const resizeCardSizeByDelta = (current, availableSizes, deltaY) => {
  const steps = Math.round(deltaY / 28);
  if (steps === 0) return normalizeCardLayoutSize(current);
  let size = normalizeCardLayoutSize(current);
  const direction = steps > 0 ? 1 : -1;
  for (let i = 0; i < Math.abs(steps); i += 1) {
    size = cycleCardSize(size, availableSizes, direction);
  }
  return size;
};
